module.exports = __webpack_public_path__ + "img/logo_base_metropolitana.fe1fb9d7.png";